<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 font-weight-bold">Fußbodenheizung</div>
    <div class="col-12 col-md-8 col-xl-9">
      <div class="row">
        <div class="col-6">
          <button 
            type="button"
            :class="['btn btn-sm btn-outline-filter', filterUiState('underfloorHeating', items[0].value)]"
            v-on:click="selectValue(items[0].value)"
          >mit
          </button>
        </div>
        <div class="col-6">
          <button type="button"
          :class="['btn btn-sm btn-outline-filter', filterUiState('underfloorHeating', items[1].value)]"
            v-on:click="selectValue(items[1].value)"
          >ohne
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionunderfloorHeating',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Fußbodenheizung',
      items: [
        { title: 'mit', value: 'ufh-1' },
        { title: 'ohne', value: null }
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('underfloorHeating', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value !== null ? Number(value.split('-')[1]) : null
      })

      this.$store.dispatch('filter/setValue', {
        name: 'underfloorHeating',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
